import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProjectCard from "./ProjectCard";
import { motion } from "framer-motion";
import { getProjects } from "../services/api";

export default function FeaturedProjects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getProjects()
      .then((res) => {
        const featured = res.data.filter((p) => p.featured);
        setProjects(featured);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="relative py-36 bg-white overflow-hidden">

      {/* Layered Atmosphere */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-blue-50 blur-3xl opacity-60"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">

        {/* Section Header */}
        <div className="mb-20 text-center">
          <p className="text-sm uppercase tracking-widest text-blue-600 font-semibold mb-4">
            Portfolio
          </p>

          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-slate-900">
            Featured Projects
          </h2>

          <p className="text-lg leading-relaxed text-slate-600 mt-6 max-w-2xl mx-auto">
            Selected backend systems and full-stack applications
            demonstrating scalable architecture and performance-focused design.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{
                duration: 0.9,
                delay: index * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <ProjectCard project={project} />
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <Link
            to="/projects"
            className="
              inline-flex items-center gap-2
              bg-blue-600
              hover:bg-blue-700
              text-white
              px-10 py-4
              rounded-full
              font-medium
              transition duration-300
              hover:-translate-y-1
              hover:shadow-xl
              hover:shadow-blue-500/20
            "
          >
            View All Projects
            <span className="transition-transform group-hover:translate-x-1">
              →
            </span>
          </Link>
        </div>

      </div>
    </section>
  );
}